export default __webpack_public_path__ + "static/media/vpa.cec4be7a.png";